<template>
  <div class="flex flex-col space-y-5">
    <div class="text-center">
      Choose a Base Wall
    </div>
    <div class="">
      <div class="flex flex-wrap -mx-2">

        <IconButton v-show="nfpa" :on-click="() => $emit('update:modelValue', 'steel-frame')" :is-active="modelValue === 'steel-frame'">
          STEEL FRAME
          <template v-slot:icon>
            <img src="../../../img/wall-builder/layers/01-steel.png" class="-mb-[25px]" />
          </template>
        </IconButton>
        <IconButton :on-click="() => $emit('update:modelValue', 'masonry')" :is-active="modelValue === 'masonry'">
          MASONRY
          <template v-slot:icon>
            <img src="../../../img/wall-builder/layers/01-mason.png" class="-mb-[25px]" />
          </template>
        </IconButton>
          <IconButton v-show="!nfpa" :on-click="() => $emit('update:modelValue', 'wood-frame')" :is-active="modelValue === 'wood-frame'">
              WOOD FRAME
              <template v-slot:icon>
                  <img src="../../../img/wall-builder/layers/01-wood.png" class="-mb-[25px]" />
              </template>
          </IconButton>
<!--        <IconButton v-show="!nfpa" :on-click="() => $emit('update:modelValue', 'frw-studs')" :is-active="modelValue === 'frw-studs'">-->
<!--          FIRE-RETARDANT WOOD (FRW) STUDS-->
<!--          <template v-slot:icon>-->
<!--            <img src="../../../img/wall-builder/layers/01-wood-spray.png" class="-mb-[25px]" />-->
<!--          </template>-->
<!--        </IconButton>-->
      </div>
    </div>
  </div>
</template>

<script>
import IconButton from "../components/IconButton.vue";
export default {
  data() {
    return {

    }
  },
  emits: ['update:modelValue'],
  props: {
    nfpa: Boolean,
    modelValue: {
      type: String,
      default: null
    }
  },
  components: {
    IconButton
  }
}
</script>
